var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.789 16.0936L16.4972 12.8018C17.0957 11.6048 17.4947 10.2083 17.4947 8.81181C17.4947 4.12353 13.7042 0.333008 9.01591 0.333008C4.32763 0.333008 0.537109 4.12353 0.537109 8.81181C0.537109 13.5001 4.32763 17.2906 9.01591 17.2906C10.4124 17.2906 11.8089 16.8916 13.0059 16.2931L16.2977 19.5849C17.2952 20.5824 18.7915 20.5824 19.789 19.5849C20.6867 18.5874 20.6867 17.0911 19.789 16.0936ZM9.01591 15.2956C5.42489 15.2956 2.53212 12.4028 2.53212 8.81181C2.53212 5.22079 5.42489 2.32802 9.01591 2.32802C12.6069 2.32802 15.4997 5.22079 15.4997 8.81181C15.4997 12.4028 12.6069 15.2956 9.01591 15.2956Z",
    fill: "#161E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN);
export default __webpack_public_path__ + "static/media/n.a8aa5092b3e5f2944e3d6266e00ae062.svg";
export { ForwardRef as ReactComponent };